import React from 'react'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import HosIntranetKeyFeatures from '../molecules/HospitalIntranetComponents/HosIntranetKeyFeatures/HosIntranetKeyFeatures'
import HosFeatureBox from '../molecules/HospitalIntranetComponents/HosFeatureBox/HosFeatureBox'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import AppsMaintenance from '../molecules/AppsSupportComponents/AppsMaintenance/AppsMaintenance'
import { getPageData, useData } from '../../app/helper/functions'
import HosIntranetIdeaProject from '../molecules/HospitalIntranetComponents/HosIntarnetIdeaProject/HosIntarnetIdeaProject'
import ReliabilityHosIntranet from '../molecules/HospitalIntranetComponents/ReliabilityHosIntranet/ReliabilityHosIntranet'
import { motion } from 'framer-motion'

// Animation variants
const fadeIn = {
    hidden: { opacity: 0 },
    visible: { 
        opacity: 1,
        transition: { duration: 0.8 }
    }
}

const slideInFromLeft = {
    hidden: { x: -100, opacity: 0 },
    visible: { 
        x: 0, 
        opacity: 1,
        transition: { duration: 0.8, ease: "easeOut" }
    }
}

const slideInFromRight = {
    hidden: { x: 100, opacity: 0 },
    visible: { 
        x: 0, 
        opacity: 1,
        transition: { duration: 0.8, ease: "easeOut" }
    }
}

const HospitalIntranetPage = () => {
    const { data } = useData();
    const hospitalIntranetData = getPageData(data, 'hospitalIntranetPage');
    return (
        <div>
            <motion.div 
                className='bg-hospitalIntranet-bg bg-center bg-cover bg-no-repeat'
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.1 }}
                variants={fadeIn}
            >
                <div className='bg-blackTransparent'>
                    <div className='flex flex-col md:flex-row md:pr-[10%] pb-8 gap-6 pt-20 md:pt-52 px-4 md:px-0'>
                        {/* <motion.img 
                            src={images.ENTERPRISEHOMEIMAGE} 
                            className='z-10 w-full md:w-[60%]'
                            variants={slideInFromLeft}
                        /> */}
                        <div  className='z-10 w-full md:w-[100%]'></div>
                        <motion.div 
                            className='text-white flex flex-col gap-2 relative text-center md:text-end justify-end items-end'
                            variants={slideInFromRight}
                        >
                            <div className='font-bold text-3xl md:text-6xl mb-2 text-end'>{hospitalIntranetData.title}</div>
                            <div className='font-normal text-lg md:text-2xl'>{hospitalIntranetData.description}</div>
                        </motion.div>
                    </div>
                </div>
            </motion.div>
            <div className='bg-darkGreyPrimary'>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-100px" }}
                    variants={fadeIn}
                >
                    <Heading className='bg-darkGreyPrimary pt-8 md:pt-12 px-4 md:px-0'
                        subTitle='Reasons to select a custom hospital intranet'
                        text="The hospital intranet system is not merely a communication tool. It is fundamental to the
                            hospital's operations, enabling staff to work together efficiently, find important resources, and
                            keep up with hospital announcements. These customized systems are designed to address
                            the specific needs of healthcare professionals and administrators, offering features
                            that improve productivity, security, and compliance." />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-100px" }}
                    variants={fadeIn}
                >
                    <ReliabilityHosIntranet hospitalIntranetData={hospitalIntranetData} />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-100px" }}
                    variants={fadeIn}
                >
                    <Heading className='bg-darkGreyPrimary pt-8 md:pt-12 px-4 md:px-0'
                        subTitle='How we develop hospital dashboards'
                        text='Our approach to designing and implementing hospital dashboards is organized, making
                     sure your facility works better with instant access to data.' />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-100px" }}
                    variants={fadeIn}
                >
                    <HosIntranetIdeaProject hospitalIntranetData={hospitalIntranetData} />
                </motion.div>

                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-100px" }}
                    variants={fadeIn}
                >
                    <HosFeatureBox />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-100px" }}
                    variants={fadeIn}
                >
                    <HosIntranetKeyFeatures hospitalIntranetData={hospitalIntranetData} />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-100px" }}
                    variants={fadeIn}
                >
                    <ProjectDisplay />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-100px" }}
                    variants={fadeIn}
                >
                    <AppsFaq />
                </motion.div>
                
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, margin: "-100px" }}
                    variants={fadeIn}
                >
                    <AppsMaintenance bgImage='bg-maintenance-hospital-bg' title='Launch your personalized software development project today.' subtitle='Is your hospital ready for an upgrade with a unique software solution?' />
                </motion.div>
                
                <DefaultFooter />
            </div>
        </div>
    )
}

export default HospitalIntranetPage
